import React from "react";
import "./index.less";
import Tick from "./Tick";

interface HkConsolidateProps {
    orderOriginalId: string;
}

const HkConsolidate: React.FC<HkConsolidateProps> = function (props) {
    const { orderOriginalId } = props;

    return (
        <div
            className="p5 consolidate"
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <h2 className="fb">
                集运订单请直接发至集运仓库
                <small>
                    （详细信息请
                    <a href="https://mms.pinduoduo.com/daxue/detail?courseId=5460" target="_blank">
                        查看课程
                    </a>
                    ）
                </small>
            </h2>

            <div className="flex progress-item">
                <Tick />

                <div className="f1 ml10">
                    <h3 className="fb">商家直接发货至集运仓库</h3>

                    <span className="text-gray">
                        订单收件人信息已替换为集运仓地址，打单发货时请
                        <span className="highlight">复制完整的收货信息(包括地址后识别码)</span>
                    </span>
                </div>
            </div>

            <div className="flex progress-item">
                <Tick />

                <div className="f1 ml10">
                    <h3 className="fb">集运仓库二次发货至消费者</h3>

                    <span className="text-gray">集运仓入库后将重新打包，并将包裹转运至消费者实际地址</span>
                </div>
            </div>

            <div className="flex progress-item">
                <Tick />

                <div className="f1 ml10">
                    <h3 className="fb">消费者信息 / 中转状态 / 二段轨迹信息查看请移步至商家后台</h3>

                    <span className="text-gray">
                        若您需要查看消费者信息/中转状态 / 最新二段物流轨迹，请前往拼多多商家后台
                        <a
                            href={`https://mms.pinduoduo.com/orders/detail?type=4399&sn=${orderOriginalId}`}
                            target="_blank"
                        >
                            查看订单
                        </a>
                    </span>
                </div>
            </div>
        </div>
    );
};

export default React.memo(HkConsolidate);
